import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import emailValidateSuccessIllustration from '../../assets/images/email-validation-success.svg';
import { contentEmailValidationSuccess } from '../../constant';

type Props = { email: string };

const EmailValidationSuccess = ({ email }: Props) => {
  const content = contentEmailValidationSuccess;

  return (
    <Grid container spacing="40px" sx={{ padding: '64px 34px 64px 34px' }}>
      <Grid item xs={12} sm={3} md={4} lg={3} container direction="column">
        <Typography
          data-test-id="email-validation-success-heading"
          variant="h5"
          sx={{ marginBottom: '33px' }}
        >
          {content.heading}
        </Typography>
        <Typography
          data-test-id="email-validation-success-body1"
          variant="body1"
          sx={{ marginBottom: '33px' }}
        >
          {content.body1}
          <strong>{email}</strong>
          {content.body2}
        </Typography>
      </Grid>
      <Grid item xs={8} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Box
          component="img"
          maxWidth="375px"
          marginTop="8px"
          alt="Check your inbox"
          src={emailValidateSuccessIllustration}
        />
      </Grid>
    </Grid>
  );
};

export default EmailValidationSuccess;
